import { createAction } from '@saucelabs/sl-util-redux';

import * as types from './types';

export const initialized = createAction(types.INITIALIZED);
export const cleanup = createAction(types.CLEANUP);
export const toggleJobSelection = createAction(types.JOB_SELECTION_TOGGLE);
export const clearJobSelection = createAction(types.JOB_SELECTION_CLEAR);
